import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Popup } from 'semantic-ui-react';
import { GeneratorErrorInfo } from 'app/interfaces/Image';
import {
  getErrorTranslationKey,
  getWarningTranslationKey,
} from 'app/xray/generator/getGeneratorErrorTranslationKey';

type AcquisitionGeneratorErrorWarningProps = {
  generatorError?: GeneratorErrorInfo;
  isDismissed?: boolean;
  onChange?: (state: boolean) => void;
};

export default function AcquisitionGeneratorErrorWarning({
  generatorError,
  isDismissed,
  onChange,
}: AcquisitionGeneratorErrorWarningProps) {
  if (
    !generatorError ||
    (generatorError.errorCodes.length === 0 && generatorError.warningCodes.length === 0)
  ) {
    return null;
  }

  const onOpen = useCallback(() => {
    onChange?.(false);
  }, [onChange]);

  const onClose = useCallback(() => {
    onChange?.(true);
  }, [onChange]);

  const hasError = generatorError.errorCodes.length > 0 || generatorError.warningCodes.length > 0;
  const isOpen = hasError && !isDismissed;
  const isAlreadyDismissedOnce = isDismissed !== undefined;

  return (
    <div className="image-render-generator-error" data-testid="generator-error-warning">
      <Popup
        open={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        on={isAlreadyDismissedOnce ? 'hover' : 'click'}
        content={
          <div>
            {generatorError.errorCodes.map((code) => (
              <div key={`error-${code}`}>
                <FormattedMessage id={getErrorTranslationKey(code)} />
              </div>
            ))}
            {generatorError.warningCodes.map((code) => (
              <div key={`warning-${code}`}>
                <FormattedMessage id={getWarningTranslationKey(code)} />
              </div>
            ))}
          </div>
        }
        trigger={<i className="svg-icon xray-warning" style={{ cursor: 'pointer' }} />}
        position="bottom center"
      />
    </div>
  );
}
